import React from "react";
import { Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import "./FilterButton.scss";

const FilterButton = ({
  onClick,
  activeFiltersCount = 0,
  isSmallScreen = false,
  translations = {
    filter: "Filter",
  },
  ...props
}) => {
  return (
    <Button
      type="default"
      icon={<FilterOutlined />}
      onClick={onClick}
      className={`filter-button ${
        activeFiltersCount > 0 ? "filter-button-active" : ""
      }`}
      {...props}
    >
      {!isSmallScreen && (
        <span className="filter-button-text">
          {translations.filter}
          {activeFiltersCount > 0 && (
            <span className="filter-count">({activeFiltersCount})</span>
          )}
        </span>
      )}
    </Button>
  );
};

export default FilterButton;